import { useTranslation } from "react-i18next";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/v2/alert-dialog";
import { truncateText } from "@/lib/helpers/common";

interface DeleteConfirmProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: () => void;
  isLoading?: boolean;
  name?: string;
  entityType?: "user" | "client";
}

export function DeleteConfirm({
  open,
  onOpenChange,
  onDelete,
  isLoading,
  name,
  entityType = "user",
}: DeleteConfirmProps) {
  const { t } = useTranslation();

  const handleDelete = () => {
    onDelete();
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("delete.title", {
              name: truncateText(name),
            })}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t("delete.description", { entity: t(`common.${entityType}`) })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>
            {t("common.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            onClick={handleDelete}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <div className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent mr-2" />
                {t("common.deleting")}
              </>
            ) : (
              t("delete.confirm")
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
